import React, { useState } from 'react'
import PageTitle from '../components/PageTitle'
import { designs } from '../data'
import { TbZoomInArea } from 'react-icons/tb'
import Modal from '../components/Modal'
import { useEffect } from 'react'
import Loading from '../components/Loading'
const Designs = () => {
  const [show, setshow] = useState(false)
  const [loading, setLoading] = useState(true)
  const [img, setimg] = useState({
    title:'',
    src:'',
    tags:[]
  })

  useEffect(()=>{
    setTimeout(() => {
        setLoading(false)
    }, 2000);
  },[])

  return (
     <section className='designs_page'>
      <PageTitle title='Designs' />
      <h1>Here some of my works. I wish you find some of what are you looking for.</h1>
      <Modal setshow={setshow} show={show}>
        {
          <div className='design_card'>
            <h3>{img?.title}</h3>
            <img src={img?.src} alt={img?.title} />
            <div className="tags">
              {
                img?.tags.map((tag, idx) => {
                  return (
                    <span key={idx}>{tag}</span>
                  )
                })
              }
            </div>
          </div>
        }
      </Modal>
      <div className="designs_container">
        {
          designs ? designs.map(({src, title, tags}, idx) => {
            return(
              loading ? <Loading key={idx} /> : <div key={idx} className="design_card">
                <div className="overlay">
                  <TbZoomInArea onClick={() => {
                    setimg({ ...img, src: src, title: title, tags: tags })
                    setshow(true)
                  }} />
                </div>
                <div className="tags">
                  {
                    tags.map((tag, idx) => {
                      return (
                        <span key={idx}>{tag}</span>
                      )
                    })
                  }
                </div>
                <img src={src} alt={title} />
              </div>
            )
          })
          : 'No thing'
        }
      </div>
    </section>
  )
}

export default Designs